'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lio_intela_sites_digitalinternship_data_Segments$ImplSection(eyebrow, title, points) {
  this.im = null;
  this.gx = null;
  this.io = null;
  this.im = eyebrow;
  this.gx = title;
  this.io = points;
}
export { $c_Lio_intela_sites_digitalinternship_data_Segments$ImplSection as $c_Lio_intela_sites_digitalinternship_data_Segments$ImplSection };
$p = $c_Lio_intela_sites_digitalinternship_data_Segments$ImplSection.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lio_intela_sites_digitalinternship_data_Segments$ImplSection;
/** @constructor */
function $h_Lio_intela_sites_digitalinternship_data_Segments$ImplSection() {
}
export { $h_Lio_intela_sites_digitalinternship_data_Segments$ImplSection as $h_Lio_intela_sites_digitalinternship_data_Segments$ImplSection };
$h_Lio_intela_sites_digitalinternship_data_Segments$ImplSection.prototype = $p;
$p.N = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.s = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().W(this, 887923772, true);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lio_intela_sites_digitalinternship_data_Segments$ImplSection)) {
    if (((this.im === x$0.im) && (this.gx === x$0.gx))) {
      var x = this.io;
      var x$2 = x$0.io;
      return ((x === null) ? (x$2 === null) : x.i(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.t = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().V(this);
});
$p.G = (function() {
  return 3;
});
$p.I = (function() {
  return "ImplSection";
});
$p.H = (function(n) {
  switch (n) {
    case 0: {
      return this.im;
      break;
    }
    case 1: {
      return this.gx;
      break;
    }
    case 2: {
      return this.io;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lio_intela_sites_digitalinternship_data_Segments$ImplSection(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.bD)));
}
export { $isArrayOf_Lio_intela_sites_digitalinternship_data_Segments$ImplSection as $isArrayOf_Lio_intela_sites_digitalinternship_data_Segments$ImplSection };
var $d_Lio_intela_sites_digitalinternship_data_Segments$ImplSection = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lio_intela_sites_digitalinternship_data_Segments$ImplSection, "io.intela.sites.digitalinternship.data.Segments$ImplSection", ({
  bD: 1,
  b: 1,
  e: 1,
  a: 1
}));
export { $d_Lio_intela_sites_digitalinternship_data_Segments$ImplSection as $d_Lio_intela_sites_digitalinternship_data_Segments$ImplSection };
//# sourceMappingURL=io.intela.sites.digitalinternship.data.-Segments$-Impl-Section.js.map
